module.exports = __webpack_public_path__ + "img/Gaming Esport Logo Vol. 08-01.jpg";